import type { LucideIcon } from "lucide-react";
import {
  CircleDotIcon,
  GaugeIcon,
  SailboatIcon,
  ShipIcon,
  ShipWheelIcon,
  WavesIcon,
  WindIcon,
  WrenchIcon,
  ZapIcon,
} from "lucide-react";
import * as z from "zod";
import { VesselSource, VesselType } from "~/graphql/generated";

export const vesselSchema = z.object({
  name: z.string().min(1, "Vessel name is required"),
  vesselType: z.enum(VesselType),
  source: z.enum(VesselSource),
  make: z.string().optional(),
  model: z.string().optional(),
  yearBuilt: z.union([z.number(), z.nan()]).optional(),
  homePort: z.string().optional(),
  flagState: z.string().optional(),
  registration: z.string().optional(),
  callSign: z.string().optional(),
  mmsiNumber: z.string().max(9).optional(),
  lengthM: z.union([z.number(), z.nan()]).optional(),
  beamM: z.union([z.number(), z.nan()]).optional(),
  draftM: z.union([z.number(), z.nan()]).optional(),
  enginePowerKw: z.union([z.number(), z.nan()]).optional(),
  fuelCapacityL: z.union([z.number(), z.nan()]).optional(),
  waterCapacityL: z.union([z.number(), z.nan()]).optional(),
  berths: z.union([z.number(), z.nan()]).optional(),
  maxPassengers: z.union([z.number(), z.nan()]).optional(),
  charterCompanyName: z.string().optional(),
  charterCompanyContact: z.string().optional(),
  charterStartDate: z.string().optional(),
  charterEndDate: z.string().optional(),
});

export type VesselFormValues = z.infer<typeof vesselSchema>;

export const TYPE_OPTIONS = [
  { value: "MONOHULL", label: "Monohull", Icon: SailboatIcon },
  { value: "CATAMARAN", label: "Catamaran", Icon: WavesIcon },
  { value: "TRIMARAN", label: "Trimaran", Icon: WindIcon },
  { value: "MOTOR_SAILER", label: "Motor Sailer", Icon: ZapIcon },
  { value: "TALL_SHIP", label: "Tall Ship", Icon: ShipIcon },
  { value: "KEELBOAT", label: "Keelboat", Icon: ShipWheelIcon },
  { value: "DINGHY", label: "Dinghy", Icon: CircleDotIcon },
  { value: "RIB", label: "RIB", Icon: GaugeIcon },
  { value: "OTHER", label: "Other", Icon: WrenchIcon },
] as const satisfies ReadonlyArray<{ value: VesselType; label: string; Icon: LucideIcon }>;
